// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"Content_content-wrapper__a4FJs"};